export default __webpack_public_path__ + "static/media/EM0870.34I-22722_-15178_0.d9b8be01.jpg";